import * as React from 'react';
import { Switch, Route } from 'react-router-dom';
import NotFound from './components/NotFound';
import Header from './components/Header';
import HomeFooterCopyrights from './components/HomeFooterCopyrights';
import Career from './containers/Career';
import Category from './containers/Category';
import DefaultCategory from './containers/DefaultCategory';
import Grocery from './containers/Grocerys';
import Tags from './containers/Tags';
import Posts from './containers/Posts';
import Pages from './containers/Pages';
import Contact from './containers/Contact';
import Products from './containers/Products';
import DetailProduct from './containers/DetailProduct';
import DetailGrocery from './containers/DetailGrocery';
import Stores from './containers/Stores';
import CateStores from './containers/CateStores';
import DetailStore from './containers/DetailStore';
import Home from './containers/Home';
import api from './services';

class App extends React.Component<any, any> {

	constructor(props) {
		super(props);
		this.state = {
			active: false
		};
	}

	componentDidMount() {
		api.getSetting().then(res => {
			sessionStorage.setItem('data_social', JSON.stringify(res.data));
		});
	}

	componentDidUpdate(preProps, preState) {
		if (preState.active) {
			var menu: any = document.getElementById('menuMB');
			var div: any = document.getElementById('divMB');
			menu.classList.remove("active");
			div.classList.remove("active");
		}
	}

	activeMenu = () => {
		this.setState({
			active: !this.state.active
		});
		setTimeout(() => {
			this.setState({
				active: false
			});
		}, 8000);
	};

	public render() {
		return (
			<div className="website-c">
				<Header active={this.state.active} activeMenu={this.activeMenu}/>
				<Switch>
					<Route path="/" exact={true} component={Home}/>}/>
					<Route path="/grocery/:post_id?/:post_slug?" component={DetailGrocery}/>}/>
					<Route path="/grocerys" component={Grocery}/>}/>
					<Route path="/career" component={Career}/>}/>
					<Route path="/contact" component={Contact}/>}/>
					<Route path="/category/:cate_slug?" component={Category}/>}/>
					<Route path="/posts/tin-tuc" component={DefaultCategory}/>}/>
					<Route path="/tag/:tag_slug?" component={Tags}/>}/>
					<Route path="/post/:cate_slug?/:post_id?/:post_slug?" component={Posts}/>}/>
					<Route path="/page/:post_id?/:post_slug?" component={Pages}/>}/>
					<Route path="/products" component={Products}/>}/>
					<Route path="/product-category/:cate_id?/:cate_slug?" component={Products}/>}/>
					<Route path="/product/:post_id?/:post_slug?" component={DetailProduct}/>}/>
					<Route path="/stores" component={Stores}/>}/>
					<Route path="/store/:cate_id?/:cate_slug?" component={CateStores}/>}/>
					<Route path="/store-detail/:cate_slug?/:post_id?/:post_slug?" component={DetailStore}/>}/>
					<Route component={NotFound}/>
				</Switch>
				{window.location.pathname != '/stores' ? <HomeFooterCopyrights/> : '' }
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx